/**
 * 认证API接口
 */
import { api } from './api';

export interface RegisterRequest {
  email: string;
  username: string;
  password: string;
}

export interface LoginRequest {
  email?: string;
  username?: string;
  password: string;
}

export interface User {
  id: number;
  email: string;
  username: string;
  role?: string;   // basic | pro | admin(多租户: admin 看全部 + 可设模板)
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface AuthResponse {
  user: User;
  token: string;
}

export interface VerifyTokenResponse {
  valid: boolean;
  user_id?: number;
  email?: string;
  username?: string;
  error?: string;
}

export const authAPI = {
  /**
   * 用户注册
   */
  register: async (data: RegisterRequest) => {
    const response = await api.post<{ success: boolean; message: string; data: AuthResponse }>(
      '/auth/register',
      data
    );
    return response.data;
  },

  /**
   * 用户登录
   */
  login: async (data: LoginRequest) => {
    const response = await api.post<{ success: boolean; message: string; data: AuthResponse }>(
      '/auth/login',
      data
    );
    return response.data;
  },

  /**
   * 获取当前用户信息
   */
  getCurrentUser: async () => {
    const response = await api.get<{ success: boolean; message: string; data: { user: User } }>(
      '/auth/me'
    );
    return response.data;
  },

  /**
   * 验证token
   */
  verifyToken: async (token?: string) => {
    try {
      const response = await api.post<{ success: boolean; message: string; data: VerifyTokenResponse }>(
        '/auth/verify',
        token ? { token } : {}  // 即使没有token也发送空对象，避免axios传递undefined导致的问题
      );
      return response.data;
    } catch (error: any) {
      // 如果返回 400 错误（MISSING_TOKEN），视为无效 token
      if (error.response?.status === 400) {
        return {
          success: true,
          message: 'success',
          data: {
            valid: false,
            error: '未提供token'
          }
        };
      }
      // 其他错误继续抛出
      throw error;
    }
  },

  /**
   * 用户登出
   */
  logout: async () => {
    const response = await api.post<{ success: boolean; message: string; data: {} }>(
      '/auth/logout'
    );
    return response.data;
  },

  /**
   * 凭邮件 token 完成邮箱验证
   */
  verifyEmail: async (token: string) => {
    const response = await api.post<{ success: boolean; message: string; data: { already_verified?: boolean } }>(
      '/auth/verify-email',
      { token }
    );
    return response.data;
  },

  /**
   * 已登录用户重新发送验证邮件
   */
  resendVerification: async () => {
    const response = await api.post<{ success: boolean; message: string; data: {} }>(
      '/auth/resend-verification'
    );
    return response.data;
  },

  /**
   * 忘记密码 - 触发发送重置邮件
   */
  forgotPassword: async (email: string) => {
    const response = await api.post<{ success: boolean; message: string; data: {} }>(
      '/auth/forgot-password',
      { email }
    );
    return response.data;
  },

  /**
   * 凭邮件 token 重置密码
   */
  resetPassword: async (token: string, newPassword: string) => {
    const response = await api.post<{ success: boolean; message: string; data: {} }>(
      '/auth/reset-password',
      { token, new_password: newPassword }
    );
    return response.data;
  },
};



